import { BreadcrumbStateInfo } from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import { Messages } from '../../../gen-src/Localize';

export function createCatalogBreadcrumb(
  urls: SiteUrls,
  urlSuffix = ''
): BreadcrumbStateInfo {
  return {
    id: 'catalog',
    text: Messages.ExternalAssets(),
    href: urls.catalogUrl() + urlSuffix,
    tooltip: Messages.ExternalAssets(),
    testId: 'breadcrumb-catalog',
  };
}

export function createCatalogDatabasesBreadcrumb(
  urls: SiteUrls,
  urlSuffix = ''
): BreadcrumbStateInfo {
  // Everything but href intentionally same as root catalog breadcrumb.
  // This matches the behavior of the "Explore" breadcrumb.
  return {
    id: 'catalog',
    text: Messages.ExternalAssets(),
    href: urls.catalogDatabasesUrl() + urlSuffix,
    tooltip: Messages.ExternalAssets(),
    testId: 'breadcrumb-catalog',
  };
}

export function createCatalogTablesBreadcrumb(
  urls: SiteUrls,
  urlSuffix = ''
): BreadcrumbStateInfo {
  // Everything but href intentionally same as root catalog breadcrumb.
  // This matches the behavior of the "Explore" breadcrumb.
  return {
    id: 'catalog',
    text: Messages.ExternalAssets(),
    href: urls.catalogTablesUrl() + urlSuffix,
    tooltip: Messages.ExternalAssets(),
    testId: 'breadcrumb-catalog',
  };
}

export function createCatalogTableBreadcrumb(
  tableId: string,
  tableName: string,
  urls: SiteUrls,
  urlSuffix = ''
): BreadcrumbStateInfo {
  return {
    id: 'catalog-table-' + tableId,
    text: tableName,
    href: urls.catalogTableUrl(tableId) + urlSuffix,
    tooltip: tableName,
    testId: 'breadcrumb-catalog-table-' + tableId,
  };
}

export function createCatalogDatabaseBreadcrumb(
  databaseId: string,
  databaseName: string,
  urls: SiteUrls,
  urlSuffix = ''
): BreadcrumbStateInfo {
  return {
    id: 'catalog-database-' + databaseId,
    text: databaseName,
    href: urls.catalogDatabaseUrl(databaseId) + urlSuffix,
    tooltip: databaseName,
    testId: 'breadcrumb-catalog-database-' + databaseId
  };
}
